<template>
  
    <div :class="matchObj">
        <span><img :src="preview_img" style="width:120px; height:67.5px;"/></span>
        <p><a :href="url" target="_blank">{{title}}</a></p>
        <p>game : {{game}} (by {{publisher}})
          <a v-if="highTime.length === 3" :href="highUrl" target="_blank">(하이라이트)</a>
        </p>
        <p>created_at : {{created_at}}</p>
        <apexchart v-if="showChart" ref="chart" height="100" width="500" type="area" :options="options" :series="series"></apexchart>
    </div>
  
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {

  props: {
    vid: { type:Number, required: true },
    showChart: { type:Boolean, required: false, default: false },
    matched: {type:Boolean, required:false, default: false }
  },

  data: ()=>({
      url: "",
      title: "",
      game: "",
      publisher: "",
      preview_img: "",
      created_at: "",
      
      highTime: [],
      
      buckets: [],
      options: {
        chart: {
            stacked: false,
            /*events:{
              dataPointSelection: (e, ctx, cfg)=> {
                debugger;
                //t=02h00m12s 
              } 
            },*/
            zoom: {
              type: 'x',
              enabled: true
            },
            toolbar: {
              show: false
            }
        },
        markers: {
          size: 0,
          style: 'full',
        },
        tooltip:{
          intersect: true,
          shared: false
        },
        grid: {
          show: false
        },
        stroke: {
          show: true,
          curve: 'smooth',
          lineCap: 'butt',
          width: 0.5,
          dashArray: 0,      
        },
        dataLabels: {
            enabled: false
        },
        xaxis: {
          type: "time"
        }
      },
      series: [{
        name: 'data',
        data: []
      }]
  }),

  computed: {
    highUrl: function(){
      const d = moment('2019-06-14 '+this.highTime.join(":"))
                .subtract(20, 'seconds').format('HH:mm:ss');
      const df = d.toString().split(":")
      return `${this.url}?t=${df[0]}h${df[1]}m${df[2]}s`
    },
    matchObj: function(){
      return {
        'result-card-matched' : this.matched,
        'result-card' : !this.matched
      }
    }
  },

  mounted(){
  },

  beforeMount(){

      const that = this

      axios.get(`https://api.twitch.tv/kraken/videos/${this.vid}`, {
          headers: {
              'Accept':'application/vnd.twitchtv.v5+json',
              'Client-ID': 'oe7hk2wgeg3hzmqm3pvxu3kulhr4mz'
          }
      }).then(res => {
          const data = res.data
          this.url = data.url
          this.title = data.title
          this.preview_img = data.preview.large || data.preview.medium
          this.game = data.game
          this.publisher = data.channel.display_name || ""
          this.created_at = data['created_at']
      })

      axios.post('https://api.snhyun.me:8881/twitch1/_search?size=0', {
        query: { term: { vid: this.vid } },
        aggs: { 
          'group_by_timestamp': { 'date_histogram': { 'field':'timestamp', 'interval': '30s' } },
          "max_highlight": { "max_bucket": { "buckets_path": "group_by_timestamp>_count" } }
        }
      }).then(res => {
        const buckets = res.data.aggregations['group_by_timestamp'].buckets
        that.$nextTick(()=>{
          that.series[0].data = buckets.map(e => ({
            y: e['doc_count'],
            x: e['key_as_string']
          }))
          that.highTime = (res.data.aggregations['max_highlight']['keys'][0] || "").split(":")
          debugger;

        })

      })
  }
}
</script>

<style lang="css">
.result-card {
  border: 1px solid #6441a4;
  margin-bottom: 4px;
  padding: 5px;
}

.result-card-matched {
  border: 1px solid red;
  margin-bottom: 4px;
  padding: 5px;
}

</style>